module.exports = "<itpx-deliverable-state-presentation [props]=\"{props:props, conf:conf}\" [state$]=\"state$\">\n</itpx-deliverable-state-presentation>"


//////////////////
// WEBPACK FOOTER
// ./src/app/core/components/workflow-new/material/deliverable-state-container/deliverable-tile-state-container.component.html
// module id = 941
// module chunks = 0